export const defCurPage = 1;
export const defPageSize = 25;
